<template>
  <span class="plc-badge">{{ text }}</span>
</template>

<script>
export default {
  name: 'GlBadge',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.plc-badge {
  align-items: center;
  background-color: $color-blue;
  border-radius: 9px;
  color: #fff;
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  height: 20px;
  justify-content: center;
  line-height: normal;
  min-width: 50px;
  padding: 0 8px;
  white-space: nowrap;
}
</style>
